angular.module("khUtils").factory("TeamUsersFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/khutils/teamusers/', {}, {
        query: {
            isArray: true
        }
    });
}]);